module.exports = __webpack_public_path__ + "media/home-live.70e0e900.mp4";